import {DiagnosticReportId} from '@legit.health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';
import {EncounterId} from '@/shared/interfaces/Encounter';

export const ENCOUNTER_IS_BASAL_CHANGED = 'encounter.is_basal_changed';

export interface IsBasalChangedEvent extends DomainEvent {
  name: string;
  diagnosticReportId: DiagnosticReportId;
  encounterId: EncounterId;
}

export function createIsBasalChangedEvent({
  diagnosticReportId,
  encounterId
}: Omit<IsBasalChangedEvent, 'name'>): IsBasalChangedEvent {
  return Object.freeze({
    name: ENCOUNTER_IS_BASAL_CHANGED,
    diagnosticReportId,
    encounterId
  });
}
